import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class FabButtonStylingModel extends CoreStylingModel {
/**
 * ButtonStylingModel for fab button
 */
button: ButtonStylingModel;
/**
 * StylingModel for fab button tooltip
 */
tooltip: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FabButtonStylingModel_tsickle_Closure_declarations() {
/**
 * ButtonStylingModel for fab button
 * @type {?}
 */
FabButtonStylingModel.prototype.button;
/**
 * StylingModel for fab button tooltip
 * @type {?}
 */
FabButtonStylingModel.prototype.tooltip;
}

